/* eslint-disable camelcase */
/* eslint-disable padding-line-between-statements */
/* eslint-disable arrow-body-style */
import React, { useCallback, useContext, useEffect, useState, useRef, useMemo } from 'react';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import wizardStyles from 'twia-portals-wizard-components-ui/common/TWIAWizard.module.scss'
import { BreakpointTrackerContext } from '@jutro/layout';
import _ from 'lodash';
import { Loader, useModal } from '@jutro/components';
import { ClausesComponentVM } from 'ent-components-platform-react';
import { CpCoverablesService } from 'twia-capability-quoteandbind-cp';
import CommonQuoteInfoMessages from "gw-capability-quoteandbind-common-react/components/CommonQuoteInfo/CommonQuoteInfo.messages";
import { TranslatorContext } from '@jutro/locale';
import { BldgLocContext } from '../../../context/BuildingsAndLocationContext';
import TWIABuildingLocationAccordion from '../../TWIABuildingSummaryAccordions/TWIABuildingLocationAccordion/TWIABuildingLocationAccordion';
import TWIABuildingInfoAccordion from '../../TWIABuildingSummaryAccordions/TWIABuildingInfoAccordion/TWIABuildingInfoAccordion';
import TWIABuildingConstructionAccordion from '../../TWIABuildingSummaryAccordions/TWIABuildingConstructionAccordion/TWIABuildingConstructionAccordion';
// eslint-disable-next-line import/no-relative-packages
//import { TWIAMSBUtil } from '../../../../../capabilities/twia-capability-msb';
import msbInfoUtil from 'ent-capability-quoteandbind-common-react/util/MsbInfoUtil.js';
import TWIACPCoveragesUtil from '../../../util/TWIACPCoveragesUtil';
import metadata from './CoveragesStep.metadata.json5';
import messages from './CoveragesStep.messages';
import TWIAWizardMessagesMessages from '../../../../../modules-react/twia-portals-wizard-components-ui/common/TWIAWizardMessages.messages';
import MSBInfoUtil from 'ent-capability-quoteandbind-common-react/util/MsbInfoUtil.js';

function CoveragesStep(props) {
    const { id, submissionVM, updateWizardData, handleNextClick, handleCancelClick, handleEditLinkClick, authHeader, showStepper, showCoverageError, validateCoverages } = props;
    const { isComponentValid, onValidate } = useValidation(id);
    const [showErrors, setShowErrors] = useState(false);
    const [url, setUrl] = useState(null);
    const { chosenLocation, chosenBuildingIndex } = useContext(BldgLocContext);
    const translator = useContext(TranslatorContext);
    const [selectedLocation, setSelectedLocation] = chosenLocation;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [selectedBuildingIndex, setSelectedBuildingIndex] = chosenBuildingIndex;
    // eslint-disable-next-line security/detect-object-injection
    const [buildingVM, setBuildingVM] = useState(selectedLocation.buildings.children[selectedBuildingIndex]);
    const [termClausePublicID, setTermClausePublicID] = useState();
    const jobID = _.get(submissionVM, 'quoteID.value') || _.get(submissionVM, 'jobID.value');
    const sessionID = submissionVM.sessionUUID.value;
    const { showAlert, showError } = useModal();
    const breakpoint = useContext(BreakpointTrackerContext);
    const [isLoading, setIsLoading] = useState(false);
    const invalidClause = useRef();
    const validRef = useRef(isComponentValid)
    const [isCovLoading, setIsCovLoading] = useState(false);
    const coverageForm = _.get(buildingVM, 'coverageForm.value.code');
    const locations = submissionVM.lobData.commercialProperty.coverables.locations.value
    const locationIndex = _.findIndex(locations, (loc) => loc.publicID === chosenLocation[0].publicID.value);

    const setCoverageValidation = useCallback((isValid, clauseID) => {
        if (isValid === false) {
            invalidClause.current = clauseID;
        }

        if (onValidate) {
            onValidate(isValid, clauseID)
        }
    }, [onValidate]);

    useEffect(() => {
        validRef.current = isComponentValid
    }, [isComponentValid]);

    useEffect(() => {
        TWIACPCoveragesUtil.configBuildingCoveragesForBlanket_TWIA(buildingVM);
    }, []);

    const isBlanketAvailable = () => { // to make Add Balnket available
        if (_.isUndefined(submissionVM.value.errorsAndWarnings?.validationIssues?.fieldIssues)) {
            return TWIACPCoveragesUtil.isBlanketAvailable_TWIA(buildingVM);
        }
        return false;
    };
    
    // Commercial Quote - Coverages Page - Add Blanket Coverage
    const addBlanketServiceTwia = () => {
        const lastOperation = CpCoverablesService.addCPBlanket_TWIA(jobID, selectedLocation.publicID.value, buildingVM.publicID.value, sessionID, authHeader);
        lastOperation
            .then((result) => {
                buildingVM.value.blanket_TWIA = result;
                // Configure Building coverages that are included in the Blanket coverage
                TWIACPCoveragesUtil.configBuildingCoveragesForBlanket_TWIA(buildingVM);
                setBuildingVM(buildingVM);
            })
            .catch(() => showError({
                title: messages.addBlanket,
                message: messages.updateBuildingCoveragesCallFailed,
            }))
            .then(() => {
                setIsCovLoading(false);
            });
        return lastOperation;
    };
    
    const addBlanketTwia = useCallback(() => {
        // Save building coverages before adding a blanket since blanket coverage terms are derived from the building coverage terms
        let operation = syncBuildingCoverages().then(() => {
                operation = addBlanketServiceTwia();
            });
        return operation;
    }, []);
    
    // Commercial Quote - Coverages Page - Remove Blanket Coverage 
    const removeBlanketServiceTwia = () => {
        const lastOperation = CpCoverablesService.removeCPBlanket_TWIA(jobID, buildingVM.blanket_TWIA.publicID_TWIA.value, sessionID, authHeader);

        lastOperation.then(() => {
                buildingVM.value.blanket_TWIA = undefined;
                // Configure Building coverages that are included in the Blanket coverage
                TWIACPCoveragesUtil.configBuildingCoveragesForBlanket_TWIA(buildingVM);
                setBuildingVM(buildingVM);
                setIsCovLoading(false);
            })
            .catch(() => showError({
                title: messages.removeBalnket,
                message: messages.updateBuildingCoveragesCallFailed
            }))
        return lastOperation;
    }

    const removeBlanketTwia = useCallback( () => {
        let operation = removeBlanketServiceTwia().then(() => {
                // No longer assume that the building coverages included in a Blanket coverage are always editable when there
                // is no Blanket coverage.  Restore configuration from from back-end when a Blanket coverage is removed.
                operation = syncBuildingCoverages();
            });
        return operation;
    }, []);

    const syncBuildingCoverages = useCallback(async () => {
        try {
            const response = await CpCoverablesService.updateCPBuildingCoverages(jobID,
                selectedLocation.publicID.value, buildingVM.value, sessionID, authHeader)

            buildingVM.coverages.value = response.coverages
            // eslint-disable-next-line security/detect-object-injection
            selectedLocation.value.buildings[selectedBuildingIndex].coverages = response.coverages
            TWIACPCoveragesUtil.configBuildingCoveragesForBlanket_TWIA(buildingVM);  // configures if Bldg Coverage and BPP COverage are non-editable
            setBuildingVM(buildingVM)
            setSelectedLocation(selectedLocation)
            submissionVM.value.errorsAndWarnings = response.errorsAndWarnings_TWIA;
            _.set(submissionVM, `lobData.commercialProperty.coverables.locations.value[${locationIndex}]`, selectedLocation.value);
            TWIACPCoveragesUtil.syncBuildingCoverageDeductibleForAllBuildingsTwia(response, selectedLocation.value); // sync deductable for all coverages across other buildings
            updateWizardData(submissionVM);
            setIsCovLoading(null);
            validateCoverages(submissionVM)
        } catch {
            setIsCovLoading(null);
            setIsLoading(false);
            showAlert({
                title: messages.unableToAddBuilding,
                message: messages.updateBuildingCoveragesCallFailed,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: CommonQuoteInfoMessages.close,
            })
        }
    }, [authHeader, buildingVM, validateCoverages, locationIndex, jobID, selectedBuildingIndex,
        selectedLocation, sessionID, setSelectedLocation, showAlert, submissionVM,
        updateWizardData]);

    // eslint-disable-next-line consistent-return
    const onNext = useCallback(async () => {
        if (!isComponentValid) {
            setShowErrors(true);
            return false
        }

        if(showCoverageError) {
            return false;
        }

        setIsLoading(true);
        await syncBuildingCoverages()
        setIsLoading(false);
        if (validateCoverages(submissionVM)) { // DE15991
            return false;
        }
        handleNextClick();

    }, [isComponentValid, showCoverageError, syncBuildingCoverages, validateCoverages,
        submissionVM, handleNextClick])

    const loadMSBSite = () => {
        MSBInfoUtil(submissionVM, updateWizardData, authHeader).getMSBCommercialLoginUrl();
    };

    const cancelBuilding = useCallback(async () => {
        await handleCancelClick(selectedLocation, setSelectedLocation);
    }, [handleCancelClick, selectedLocation, setSelectedLocation]);

    const handleValueChange = useCallback(async (newValue, path, clause) => {
        if (clause) {
            setTermClausePublicID(() => clause.publicID);
        }

        const index = path.lastIndexOf(".");
        const newPath = path.substring(0, index);

        if (index >= 0) {
            _.set(buildingVM, `${newPath}.updated`, true);
        }

        _.set(buildingVM, path, newValue)

        if (selectedBuildingIndex >= 0) {
            selectedLocation.buildings.value.splice(selectedBuildingIndex, 1, buildingVM.value);
        } else {
            selectedLocation.buildings.value.push(buildingVM.value);
        }

        setBuildingVM(buildingVM)
        submissionVM.selectedBuilding = buildingVM.value;
        setSelectedLocation(selectedLocation)
        updateWizardData(submissionVM);
    }, [buildingVM, selectedBuildingIndex, selectedLocation, submissionVM, updateWizardData, setSelectedLocation])
    
    const [limitError, setLimitError] = useState(false);

    const handleValueChangeAndSync = useCallback(async (newValue, path, clause) => {
        await handleValueChange(newValue, path, clause);

        if (!clause) {
            setIsCovLoading(() => termClausePublicID);
        } else {
            setIsCovLoading(clause.publicID);
        }
        // const index = path.lastIndexOf(".");
        // const newPath = path.substring(0, index);
        
        // if (path.includes('.selected') || path.includes('.chosenTerm') || `${newPath}.updated` === true) {
            await syncBuildingCoverages();
        // }
        
        if  (path.includes("terms.children[2].directValue")) {
            setLimitError(true);
        }

    }, [handleValueChange, syncBuildingCoverages, termClausePublicID])

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        locationAccordion: {
            visible: showStepper,
            handleEditLinkClick
        },
        buildingAccordion: {
            visible: showStepper,
            handleEditLinkClick
        },
        constructionAccordion: {
            visible: showStepper,
            handleEditLinkClick
        },
        nextButton: {
            content: !showStepper ? translator(TWIAWizardMessagesMessages.TWIAWizardModalSave)
                : translator(TWIAWizardMessagesMessages.TWIAWizardModalNext)
        },
        wizardActionButtons: {
            justifyContent: !showStepper ? 'right' : 'between'
        },
        buildingCoveragesComponent: {
            value: buildingVM.coverages.value,
            path: 'coverages',
            loadingClause: isCovLoading,
            onValidate: setCoverageValidation,
            isComponentValid,
            showError: showErrors,
            limitError,
            splitByClauseCategory: true,
            loadMSBSite,
            msbButtonVisible: (coverageForm === 'TWCB' || coverageForm === 'TWCC' 
                || coverageForm === 'TWCH'),
            showAmount:false,
            showCoverageNameAmount : false
        },
        addButton: {
            visible: isBlanketAvailable(),
            onClick: addBlanketTwia
        },
        removeButton: {
            visible: !_.isUndefined(buildingVM.value.blanket_TWIA),
            onClick: removeBlanketTwia
        },
        blanketCoveragesComponent: {
            visible: !_.isUndefined(buildingVM.value.blanket_TWIA),
            value: buildingVM?.blanket_TWIA.coverages?.value,
            path: 'coverages',
            loadingClause: isCovLoading,
            onValidate: setCoverageValidation,
            isComponentValid,
            showError: showErrors,
            splitByClauseCategory: true,
            loadMSBSite,
            msbButtonVisible: false,
            showAmount:false,
            showCoverageNameAmount : false
        },
        cancelButton: {
            visible: showStepper // DE16023
        }

    }
    const resolvers = {
        resolveClassNameMap: wizardStyles,
        resolveCallbackMap: {
            onNext,
            handleCancelClick: cancelBuilding,
            loadMSBSite,
            handleValueChange,
            handleValueChangeAndSync
        },
        resolveComponentMap: {
            TWIABuildingLocationAccordion,
            TWIABuildingInfoAccordion,
            TWIABuildingConstructionAccordion,
            clausesComponentVM: ClausesComponentVM,
        }
    }

    return (
        <Loader loaded={!isLoading}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrideProps}
                model={buildingVM}
                onValidationChange={onValidate}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
                showErrors={showErrors}
            />
        </Loader>
    )
}


export default withAuthenticationContext(CoveragesStep);